"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawToJSON = exports.WithdrawFromJSONTyped = exports.WithdrawFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function WithdrawFromJSON(json) {
    return WithdrawFromJSONTyped(json, false);
}
exports.WithdrawFromJSON = WithdrawFromJSON;
function WithdrawFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'status': (0, _1.WithdrawStatusFromJSON)(json['status']),
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
        'user': (0, _1.UserFromJSON)(json['user']),
        'transaction': !(0, runtime_1.exists)(json, 'transaction') ? undefined : (0, _1.TransactionFromJSON)(json['transaction']),
        'wallet': !(0, runtime_1.exists)(json, 'wallet') ? undefined : json['wallet'],
        'walletChain': !(0, runtime_1.exists)(json, 'walletChain') ? undefined : (0, _1.WithdrawWalletChainFromJSON)(json['walletChain']),
        'amount': json['amount'],
        'dpayFee': json['dpayFee'],
        'hash': !(0, runtime_1.exists)(json, 'hash') ? undefined : json['hash'],
    };
}
exports.WithdrawFromJSONTyped = WithdrawFromJSONTyped;
function WithdrawToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'status': (0, _1.WithdrawStatusToJSON)(value.status),
        'notes': value.notes,
        'user': (0, _1.UserToJSON)(value.user),
        'transaction': (0, _1.TransactionToJSON)(value.transaction),
        'wallet': value.wallet,
        'walletChain': (0, _1.WithdrawWalletChainToJSON)(value.walletChain),
        'amount': value.amount,
        'dpayFee': value.dpayFee,
        'hash': value.hash,
    };
}
exports.WithdrawToJSON = WithdrawToJSON;
